import { Box, Grid } from '@mui/material';
import PageHeader from 'components/Header/Page';
import DashboardIcon from '../../assets/material-symbols_dashboard.svg';
import { useEffect, useRef, useState } from 'react';
import NumberWidget from 'components/Widgets/NumberWidget';
import moment from 'moment';
import {
	activeWorkspacesData,
	overAllCost,
	overAllDbuCount,
	spendWorkspace,
	costByTypeData,
	countByTypeData,
	runTimeWorkspace,
	costByDateData,
	countByDateData,
	workspaceLastSyn,
	workspaceGetEnv,
	fetchSectorList
} from 'service/service';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { useLocation, useNavigate } from 'react-router-dom';
import FiltersBar from './FilterBar';
import { useTheme } from "@mui/material/styles";


import { formatCompactNumber } from 'utils/adb-common-util';
import DoughnutChart from 'components/Widgets/DoughnutChart';
import RaceBarChart from 'components/Widgets/RaceBarChart';
import DualAxisLineChart from 'components/Widgets/DualAxisLineChart';

export const toTitleCase = (str: string) =>
	str.replaceAll(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
const Workspace = () => {
	const navigate = useNavigate();
	const routerLocation = useLocation();
	const navigationState = routerLocation.state as {
		startDate?: string;
		endDate?: string;
		env?: string;
		sector?: string;
		location?: string;
		selectedDateInString?: string;
		workspaceName?: string;
		computeType?: string;
		filters?: any;
		contentName?: string;
		warehouseName?: string;
		warehouseType?: string;
		userExecutedBy?: string;
		catalogName?: string;
		searchSource?: string;
	} | null;
	const theme = useTheme();
	const [lastSync, setLastSync] = useState(null);
	const [completeCost, setCompleteCost] = useState();
	const [dbuValue, setDbuValue] = useState();
	const [activeWorkspaces, setActiveWorkspaces] = useState();
	const [topTenSpend, setTopTenSpend] = useState<[{ totalSpend: number; workspace_name: string; workspace_id: string; sector: string }]>();
	const [cCost, setCCost] = useState<{ name: string; value: number }[]>([]);
	const [cCount, setCCount] = useState<{ name: string; value: number }[]>([]);
	const [topTenRunTime, setTopTenRunTime] =
		useState<[{ totalRunTime: number; workspace_name: string; workspace_id: string; sector: string }]>();
	const [costByDate, setCostByDate] = useState<
		[
			{
				totalSpend: number;
				totalRunTime: number;
				date: string;
			}
		]
	>();
	const [countByDate, setCountByDate] = useState<
		[
			{
				totalDbu: number;
				totalRunTime: number;
				date: string;
			}
		]
	>();
	const [loader, setLoader] = useState({
		fullCostLoader: false,
		fullDbuLoader: false,
		activeWorkspaceLoader: false,
		topTenWorkspaceSpendLoader: false,
		costByType: false,
		countByType: false,
		topTenRunTimeWorkspaceLoader: false,
		costByTime: false,
		countByTime: false,
		env: false
	});


	const restoredRef = useRef(false);
	const prevParamsRef = useRef<string>('');
	const PRESERVE_FILTER_KEY = 'workspace_filters';
	const yesterday = moment().tz('Asia/Kolkata').subtract(1, 'day');
	const defStartDate = yesterday.clone().subtract(89, 'days').startOf('day');

	const DEFAULT_FILTERS = {
		startDate: navigationState?.startDate || defStartDate.format('YYYY-MM-DD'),
		endDate: navigationState?.endDate || yesterday.endOf('day').format('YYYY-MM-DD'),
		env: navigationState?.env || 'both',
		sector: navigationState?.sector || 'all',
		location: navigationState?.location || 'South Central US',
		selectedDateInString: navigationState?.selectedDateInString || '3M'
	};

	const [sectorName, setSectorName] = useState(DEFAULT_FILTERS.sector);
	const [sector, setSector] = useState<string>(DEFAULT_FILTERS.sector);
	const [location, setLocation] = useState(DEFAULT_FILTERS.location);
	const [env, setEnv] = useState(DEFAULT_FILTERS.env);
	const [envOptions, setEnvOptions] = useState<{ label: string; value: string }[]>([]);
	const [startDate, setStartDate] = useState<string>(DEFAULT_FILTERS.startDate);
	const [endDate, setEndDate] = useState<string>(DEFAULT_FILTERS.endDate);
	const [selectedDateInString, setSelectedDateInString] = useState<string>(DEFAULT_FILTERS.selectedDateInString);
	const [sectorList, setSectorList] = useState<string[]>([]);

	const handleDateSelect = (stDt: string, edDt: string, selectedDate?: string) => {
		const selected = selectedDate || '3M';
		setSelectedDateInString(selected);

		// Get yesterday in user's local timezone
		const yesterday = moment().tz('Asia/Kolkata').subtract(1, 'day');
		const end = yesterday.clone().endOf('day');
		let start;

		if (selected === 'Hrs') {
			// Last 24 hours (yesterday only)
			start = yesterday.clone().startOf('day');
		} else if (selected === '7d') {
			// Last 7 days ending yesterday
			start = yesterday.clone().subtract(6, 'days').startOf('day');
		} else if (selected === '30d') {
			// Last 30 days ending yesterday
			start = yesterday.clone().subtract(29, 'days').startOf('day');
		} else if (selected === '3M') {
			// Last 3 months ending yesterday
			start = yesterday.clone().subtract(89, 'days').startOf('day');
		} else if (selected === 'custom') {
			// Custom date range - use provided dates
			start = moment(stDt).startOf('day');
			const customEnd = moment(edDt).endOf('day');
			setStartDate(start.format('YYYY-MM-DD'));
			setEndDate(customEnd.format('YYYY-MM-DD'));
			return; // Exit early for custom range
		} else {
			// Default to provided dates
			start = moment(stDt).startOf('day');
		}

		setStartDate(start.format('YYYY-MM-DD'));
		setEndDate(end.format('YYYY-MM-DD'));
	};

	const initialEnvAppliedRef = useRef(false);
	const envRef = useRef(env);
	useEffect(() => { envRef.current = env; }, [env]);
	const getEnvFetch = async (location: string) => {
		try {
			setLoader((prev) => ({
				...prev,
				env: true
			}));
			const res = await workspaceGetEnv(location);
			// BUSINESS REQUIREMENT TO SEE ALL WHENEVER THE LOCATION IS CHANGED
			const options = [{ label: 'ALL', value: 'both' }, ...(res?.data || [])];
			setEnvOptions(options);
			if (!initialEnvAppliedRef.current && navigationState?.env) {
				setEnv(navigationState.env);
				initialEnvAppliedRef.current = true;
			} else {
				const availableValues = options.map((o) => o.value);
				const current = envRef.current;
				if (!availableValues.includes(current)) {
					const fallback = availableValues.includes('both') ? 'both' : (availableValues[0] || 'both');
					setEnv(fallback);
				}
			}
			setLoader((prev) => ({
				...prev,
				env: false
			}));
		} catch (error) {
			console.error('Failed to fetch environment options:', error);
		}
	};

	const fetchLastSync = async () => {
		const res = await workspaceLastSyn();
		if (res?.success && res?.statusCode === 200) {
			const date = res.data?.End_Time;
			setLastSync(date);
		}
	};

	const formattedLastSync = lastSync
		? (() => {
			const date = new Date(lastSync);
			const weekday = date.toLocaleString('en-US', { weekday: 'short', timeZone: 'UTC' });
			const day = date.toLocaleString('en-US', { day: '2-digit', timeZone: 'UTC' });
			const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
			const year = date.toLocaleString('en-US', { year: 'numeric', timeZone: 'UTC' });
			return `${weekday}, ${day} ${month} ${year}(UTC)`;
		})()
		: 'Loading...';


	const fullCost = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			fullCostLoader: true
		}));

		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await overAllCost(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setCompleteCost(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			fullCostLoader: false
		}));
	};

	const dbuCount = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			fullDbuLoader: true
		}));

		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await overAllDbuCount(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setDbuValue(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			fullDbuLoader: false
		}));
	};

	const actWorkspaces = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			activeWorkspaceLoader: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await activeWorkspacesData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setActiveWorkspaces(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			activeWorkspaceLoader: false
		}));
	};

	const TopTenWorkspaceSpend = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			topTenWorkspaceSpendLoader: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await spendWorkspace(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setTopTenSpend(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			topTenWorkspaceSpendLoader: false
		}));
	};

	const ComputeCost = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			costByType: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await costByTypeData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setCCost(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			costByType: false
		}));
	};

	const ComputeCount = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			countByType: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await countByTypeData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setCCount(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			countByType: false
		}));
	};

	const TopTenRuntimeWorkspace = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			topTenRunTimeWorkspaceLoader: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await runTimeWorkspace(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setTopTenRunTime(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			topTenRunTimeWorkspaceLoader: false
		}));
	};

	const CostWithTime = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			costByTime: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await costByDateData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setCostByDate(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			costByTime: false
		}));
	};

	const CountWithTime = async (startDate: any, endDate: any, env: string, sector: string, location: string, selectedDateInString: string) => {
		setLoader((prev) => ({
			...prev,
			countByTime: true
		}));
		const startFormatted = startDate.split(' ')[0];
		const endFormatted = endDate.split(' ')[0];

		const resp = await countByDateData(startFormatted, endFormatted, env, sector, location, selectedDateInString);
		if (resp?.success) {
			setCountByDate(resp?.data);
		}
		setLoader((prev) => ({
			...prev,
			countByTime: false
		}));
	};

	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		notation: 'compact',
		compactDisplay: 'short',
		maximumFractionDigits: 2
	});

	const compactFormatter = new Intl.NumberFormat('en-US', {
		notation: 'compact',
		compactDisplay: 'short',
		maximumFractionDigits: 2
	});

	const handleComputeCostClick = (params: any) => {
		// ✅ Check if click is on the center (graphic) or pie slice (series)
		if (params?.componentType === 'graphic') {
			// Center click - navigate without computeType filter (show all data)
			const snap = {
				startDate,
				endDate,
				selectedDateInString,
			};
			sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));

			navigate('/databricksADB/compute-cost-details', {
				state: {
					computeType: '',
					startDate,
					endDate,
					env,
					sector: sectorName,
					location,
					selectedDateInString
				}
			});
		} else if (params?.name && params?.componentType === 'series') {
			// Pie slice click - navigate with specific computeType
			const snap = {
				startDate,
				endDate,
				selectedDateInString,
			};
			sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));

			navigate('/databricksADB/compute-cost-details', {
				state: {
					computeType: params.name,
					startDate,
					endDate,
					env,
					sector: sectorName,
					location,
					selectedDateInString
				}
			});
		}
	};

	const handleComputeCountClick = (params: any) => {
		if (params?.componentType === 'graphic') {
			// Center click - navigate without computeType filter (show all data)
			const snap = {
				startDate,
				endDate,
				selectedDateInString,
			};
			sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));

			navigate('/databricksADB/compute-count-details', {
				state: {
					computeType: '',
					startDate,
					endDate,
					env,
					sector: sectorName,
					location,
					selectedDateInString
				}
			});
		} else if (params?.name && params?.componentType === 'series') {
			// Pie slice click - navigate with specific computeType
			const snap = {
				startDate,
				endDate,
				selectedDateInString,
			};
			sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));

			navigate('/databricksADB/compute-count-details', {
				state: {
					computeType: params.name,
					startDate,
					endDate,
					env,
					sector: sectorName,
					location,
					selectedDateInString
				}
			});
		}
	};
	const COMPUTE_TYPE_COLORS: Record<string, string> = {
		'job': '#01C008',
		'interactive': '#299BFF',
		'sql': '#7F00FF',
	};

	const getConsistentColor = (computeType: string): string => {
		const normalizedType = computeType.toLowerCase().trim();
		return COMPUTE_TYPE_COLORS[normalizedType] || '#01C008';
	};

	const sortedSpend = topTenSpend && [...topTenSpend].sort((a, b) => a.totalSpend - b.totalSpend);

	const sortedTime = topTenRunTime && [...topTenRunTime].sort((a, b) => a.totalRunTime - b.totalRunTime);

	const fetchSectors = async () => {
		const resp = await fetchSectorList({});
		if (resp?.success) {
			setSectorList(resp?.data || []);
		}
	};

	useEffect(() => {
		if (!navigationState) return;

		const applyNonDateFilters = () => {
			if (navigationState.env) setEnv(navigationState.env);
			if (navigationState.sector) {
				setSector(navigationState.sector);
				setSectorName(navigationState.sector);
			}
			if (navigationState.location) setLocation(navigationState.location);
		};

		const handleFallbackDates = () => {
			setStartDate(defStartDate.format('YYYY-MM-DD'));
			setEndDate(yesterday.clone().endOf('day').format('YYYY-MM-DD'));
			setSelectedDateInString('3M');
		};

		const applyNavigationDates = (token: string) => {
			if (navigationState.startDate) setStartDate(navigationState.startDate);
			if (navigationState.endDate) setEndDate(navigationState.endDate);
			if (navigationState.selectedDateInString) setSelectedDateInString(token);
		};

		const applyPreservedDates = (p: any) => {
			if (p.startDate) setStartDate(p.startDate);
			if (p.endDate) setEndDate(p.endDate);
			if (p.selectedDateInString) setSelectedDateInString(p.selectedDateInString);
			restoredRef.current = true;
		};

		const restoreDates = () => {
			const preservedRaw = sessionStorage.getItem(PRESERVE_FILTER_KEY);
			const token = navigationState.selectedDateInString?.trim() || '';
			const isNavCustom = ['custom', 'customDateRange'].includes(token);

			if (!preservedRaw) {
				if (isNavCustom) {
					handleFallbackDates();
				} else {
					applyNavigationDates(token);
				}
				return;
			}

			const p = JSON.parse(preservedRaw);
			const isPreservedCustom = p.selectedDateInString === 'custom';

			if (isNavCustom || isPreservedCustom) {
				applyPreservedDates(p);
			}
		};

		applyNonDateFilters();
		restoreDates();

		initialEnvAppliedRef.current = false;
		setTimeout(() => {
			prevParamsRef.current = '';
		}, 0);
	}, []);

	useEffect(() => {
		if (!(startDate && endDate && env && sector && location)) return;

		const currentKey = JSON.stringify({ startDate, endDate, env, sector, location, selectedDateInString });
		// if we've already fetched for this exact params set, skip
		if (prevParamsRef.current === currentKey) return;
		prevParamsRef.current = currentKey;

		let mounted = true;
		const runAll = async () => {
			try {
				await Promise.all([
					fullCost(startDate, endDate, env, sector, location, selectedDateInString),
					dbuCount(startDate, endDate, env, sector, location, selectedDateInString),
					actWorkspaces(startDate, endDate, env, sector, location, selectedDateInString),
					TopTenWorkspaceSpend(startDate, endDate, env, sector, location, selectedDateInString),
					ComputeCost(startDate, endDate, env, sector, location, selectedDateInString),
					ComputeCount(startDate, endDate, env, sector, location, selectedDateInString),
					TopTenRuntimeWorkspace(startDate, endDate, env, sector, location, selectedDateInString),
					CostWithTime(startDate, endDate, env, sector, location, selectedDateInString),
					CountWithTime(startDate, endDate, env, sector, location, selectedDateInString),
					fetchSectors(),
					fetchLastSync()
				]);
			} catch (err) {
				console.error('Workspace fetches failed', err);
			} finally {
				if (mounted && restoredRef.current) {
					sessionStorage.removeItem(PRESERVE_FILTER_KEY);
					restoredRef.current = false;
				}
			}
		};

		runAll();
		return () => { mounted = false; };
	}, [startDate, endDate, env, sector, location, selectedDateInString]);

	useEffect(() => {
		getEnvFetch(location); // Fetch the env list only once on mount
	}, [location]);

	const updateHistoryState = (overrides: Partial<{
		startDate: string;
		endDate: string;
		env: string;
		sector: string;
		location: string;
		selectedDateInString: string;
		filters?: any;
		contentName?: string;
		workspaceName?: string;
		warehouseName?: string;
		warehouseType?: string;
		userExecutedBy?: string;
		catalogName?: string;
		searchSource?: string;
	}>) => {
		const newState = {
			startDate,
			endDate,
			env,
			sector: sectorName,
			location,
			selectedDateInString,
			searchSource: navigationState?.searchSource,
			...overrides
		};
		navigate(routerLocation.pathname, { state: newState, replace: true });
	};

	const handleLineChartOnClick = (params: any, chartType: any) => {
		// params can be an array (axis trigger) or single (series/item)
		const payloadPoint = Array.isArray(params) ? params[0] : params;
		const clickedDate = payloadPoint?.name || payloadPoint?.data?.date || null;
		if (!clickedDate) return;
		let detailedTableTitle = 'Workspace Runtime Details';
		let detailedTableType = 'workspace-runtime-detail';
		let pageSubHeader = 'Cost Vs Workspace with RunTime';
		const searchSource = `${chartType}${payloadPoint.seriesName}`;
		if (searchSource === 'dbuWorkspaceRuntimeDBU') {
			detailedTableTitle = 'DBU Details';
			detailedTableType = 'dbu-workspace-detail';
			pageSubHeader = 'DBU Vs Workspace with RunTime';
		} else if (searchSource === 'dbuWorkspaceRuntimeRunTime') {
			pageSubHeader = 'DBU Vs Workspace with RunTime';
		} else if (searchSource === 'workspaceRuntimeCost') {
			detailedTableTitle = 'Cost Details';
			detailedTableType = 'cost-workspace-detail';
		}
		localStorage.removeItem(detailedTableType);
		const snap = {
			startDate,
			endDate,
			selectedDateInString,
		};
		sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));

		// ensure YYYY-MM-DD format
		const parsed = moment(clickedDate);
		const formatted = parsed.isValid() ? parsed.format('YYYY-MM-DD') : clickedDate;

		// determine month range; if it's the current month, end = yesterday
		const tzNow = moment().tz('Asia/Kolkata');
		const isCurrentMonth = parsed.isValid() && parsed.isSame(tzNow, 'month') && parsed.isSame(tzNow, 'year');

		const clickedStartDate = parsed.isValid() ? parsed.clone().startOf('month').format('YYYY-MM-DD') : formatted;
		let clickedEndDate;
		if (parsed.isValid()) {
			if (isCurrentMonth) {
				clickedEndDate = yesterday.clone().format('YYYY-MM-DD');
			} else {
				clickedEndDate = parsed.clone().endOf('month').format('YYYY-MM-DD');
			}
		} else {
			clickedEndDate = formatted;
		}
		let newState: any = {
			startDate: formatted,
			endDate: formatted,
			clickedStartDate: clickedStartDate,
			clickedEndDate: clickedEndDate,
			env,
			sector: sectorName,
			location,
			selectedDateInString: 'customDateRange',
			searchSource: searchSource,
			contentName: 'ALL',
			detailedTableTitle: detailedTableTitle,
			detailedTableType: detailedTableType,
			pageHeader: 'Workspace Overview',
			pageSubHeader: pageSubHeader,
		};
		navigate('/databricksADB/performance-dashboard', { state: newState });
	}

	const handleBarChartOnClick = (params: any, chartType: any) => {
		if (params?.name) {
			let detailedTableTitle = 'Compute Spend Details';
			let detailedTableType = 'compute-spend-detail';
			let pageSubHeader = 'Compute Spend Details';
			if (chartType === 'runtime') {
				detailedTableTitle = 'RunTime Details';
				detailedTableType = 'runtime-detail';
				pageSubHeader = 'RunTime Details';
			}
			localStorage.removeItem(detailedTableType);
			const snap = {
				startDate,
				endDate,
				selectedDateInString,
			};
			sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));
			let newState: any = {
				startDate,
				endDate,
				env,
				sector: sectorName,
				location,
				selectedDateInString,
				searchSource: chartType,
				contentName: params.name,
				detailedTableTitle: detailedTableTitle,
				detailedTableType: detailedTableType,
				pageHeader: 'Workspace Overview',
				pageSubHeader: pageSubHeader,
				filters: [
					{
						operator: 'AND',
						field: 'Workspace ID',
						value: String(params?.data.workspace_id ?? '')
					}
				]
			};
			navigate('/databricksADB/performance-dashboard', { state: newState });
		}
	}

	const handleTilesOnClick = (chartType: any) => {
		let detailedTableTitle = 'Top Spending Workspace Details';
		let detailedTableType = 'top-spending-workspace-detail';
		let pageSubHeader = 'Top Spending Workspace Details';
		let newState: any = {
			startDate,
			endDate,
			env,
			sector: sectorName,
			location,
			selectedDateInString,
			searchSource: chartType,
			detailedTableTitle: detailedTableTitle,
			detailedTableType: detailedTableType,
			pageHeader: 'Workspace Overview',
			pageSubHeader: pageSubHeader,
		};
		if (chartType === 'topSpendingWorkspace') {
			newState = {
				...newState,
				contentName: topTenSpend?.[0]?.workspace_name,
				filters: [
					{
						operator: 'AND',
						field: 'Workspace ID',
						value: String(topTenSpend?.[0]?.workspace_id ?? '')
					}
				]
			};
		}
		localStorage.removeItem(detailedTableType);
		const snap = {
			startDate,
			endDate,
			selectedDateInString,
		};
		sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));
		navigate('/databricksADB/performance-dashboard', { state: newState });
	}

	return (
		<PageWrapper>
				<FiltersBar
					location={location}
					// pass the actual useState setters (not single-arg wrappers)
					setLocation={setLocation}
					env={env}
					setEnv={setEnv}
					envOptions={envOptions}
					setEnvOptions={setEnvOptions}
					startDate={startDate}
					endDate={endDate}
					setStartDate={setStartDate}
					setEndDate={setEndDate}
					handleDateSelect={handleDateSelect}
					selectedDateInString={selectedDateInString}
					setSelectedDateInString={setSelectedDateInString}
					sectorName={sectorName}
					// typed wrapper to handle SetStateAction<string> (function or value)
					setSectorName={(v) => {
						const resolved = typeof v === 'function' ? (v as (prev: string) => string)(sectorName) : v;
						setSectorName(resolved);
						setSector(resolved);
					}}
					updateHistoryState={updateHistoryState}
					hasYTD={true}
					sectorOptionsList={sectorList}
					searchSource={navigationState?.searchSource}
					useHeaderFilters
				/>

			<Grid container spacing={2} px={{ xs: 1, md: 2 }} pt={{ xs: 1, md: 2 }} pb={1}>
				<Grid item xs={12} sm={6} md={6} lg={3} id="overall-cost-ytd">
					<Box
						onClick={() => {
							const snap = {
								startDate,
								endDate,
								selectedDateInString,
							};
							sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));
							navigate('/databricksADB/overall-cost', {
								state: {
									startDate,
									endDate,
									env,
									sector: sectorName,
									location,
									selectedDateInString
								}
							})
						}}
						sx={{ cursor: 'pointer', height: '100%' }}
					>
						<NumberWidget
							title={<HighlightedText text="Overall Cost (YTD)" />}
							tooltipLabel={`${completeCost}`}
							number={formatter.format(completeCost ?? 0)}
							isLoading={loader.fullCostLoader}
							bgColor={theme.palette.widget.background.card}
							color={theme.palette.widget.text.title}
							valueFontWeight={400}
							sameDecimalSize={true}
						/>
					</Box>
				</Grid>
				<Grid item xs={12} sm={6} md={6} lg={3} id="total-dbus">
					<Box onClick={() => {
						const snap = {
							startDate,
							endDate,
							selectedDateInString,
						};
						sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));
						navigate('/databricksADB/total-dbu',
							{
								state: {
									startDate,
									endDate,
									env,
									sector: sectorName,
									location,
									selectedDateInString
								}
							}
						)
					}} sx={{ cursor: 'pointer', height: '100%' }}>
						<NumberWidget
							title={<HighlightedText text="Total DBUs" />}
							tooltipLabel={`${dbuValue}`}
							number={formatCompactNumber(dbuValue ?? 0)}
							units=""
							isLoading={loader.fullDbuLoader}
							bgColor={theme.palette.widget.background.card}
							color={theme.palette.widget.text.title}
							valueFontWeight={400}
							sameDecimalSize={true}
						/>
					</Box>
				</Grid>
				<Grid item xs={12} sm={6} md={6} lg={3} id="active-workspaces">
					<Box onClick={() => {
						const snap = {
							startDate,
							endDate,
							selectedDateInString,
						};
						sessionStorage.setItem(PRESERVE_FILTER_KEY, JSON.stringify(snap));
						navigate('/databricksADB/active-workspaces',
							{
								state: {
									startDate,
									endDate,
									env,
									sector: sectorName,
									location,
									selectedDateInString
								}
							}
						)
					}} sx={{ cursor: 'pointer', height: '100%' }}>
						<NumberWidget
							title={<HighlightedText text="Active Work Spaces" />}
							tooltipLabel=""
							number={compactFormatter.format(activeWorkspaces ?? 0)}
							units=""
							isLoading={loader.activeWorkspaceLoader}
							bgColor={theme.palette.widget.background.card}
							color={theme.palette.widget.text.title}
							valueFontWeight={400}
							sameDecimalSize={true}
						/>
					</Box>
				</Grid>
				<Grid item xs={12} sm={6} md={6} lg={3} id="top-spending-workspace">
					<Box onClick={() => handleTilesOnClick('topSpendingWorkspace')}
						sx={{ cursor: 'pointer', height: '100%' }}
					>
						<NumberWidget
							title={<HighlightedText text="Top Spending Workspace" />}
							tooltipLabel={`${topTenSpend?.[0]?.totalSpend ?? 0}`}
							number={formatter.format(topTenSpend?.[0]?.totalSpend ?? 0)}
							units=""
							isLoading={loader.activeWorkspaceLoader}
							subText={topTenSpend?.[0]?.workspace_name}
							bgColor={theme.palette.widget.background.card}
							color={theme.palette.widget.text.title}
							valueFontWeight={400}
							sameDecimalSize={true}
						/>
					</Box>
				</Grid>
			</Grid>
			<Grid container spacing={2} px={{ xs: 1, md: 2 }} py={{ xs: 1, md: 1.5 }}>
				<Grid item xs={12} md={4} id="compute-cost-by-type">
							<DoughnutChart
								isLoading={loader.costByType}
								title="Compute Cost by Type"
								totalText={`{small|Total}\n{large|${formatter.format(Array.isArray(cCost) ? cCost.reduce((acc, curr) => acc + curr.value, 0) : 0)}}`}
								seriesData={(Array.isArray(cCost) ? cCost.map((item) => ({
									name: item.name,
									value: item.value,
									percentage: '',
									formattedName: toTitleCase(item.name),
									color: getConsistentColor(item.name)
								})) : []) as any}
								dataLabel={false}
								legendLabel={true}
								hoursFormat={false}
								chartSize="280px"
								isCost={true}
								handleEvent={(event: any) => handleComputeCostClick(event)}
							/>
				</Grid>
				<Grid item xs={12} md={4} id="compute-count-by-type">
							<DoughnutChart
								isLoading={loader.countByType}
								title="Compute Count by Type"
								totalText={`{small|Total}\n{large|${compactFormatter.format(Array.isArray(cCount) ? cCount.reduce((acc, curr) => acc + curr.value, 0) : 0)}}`}
								seriesData={(Array.isArray(cCount) ? cCount.map((item) => ({
									name: item.name,
									value: item.value,
									percentage: '',
									formattedName: toTitleCase(item.name),
									color: getConsistentColor(item.name)
								})) : []) as any}
								dataLabel={false}
								legendLabel={true}
								hoursFormat={false}
								chartSize="280px"
								handleEvent={(event: any) => handleComputeCountClick(event)}
							/>
				</Grid>
				<Grid item xs={12} md={4} id="top-10-compute-spend">
					<RaceBarChart
						title="Top 10 Compute Spend by Workspace"
						isLoading={loader.topTenWorkspaceSpendLoader}
						valueType="cost"
						data={sortedSpend?.map((item) => ({
							name: item.workspace_name,
							value: item.totalSpend,
							workspace_id: item.workspace_id
						})) ?? []}
						series={[{ key: 'value', name: 'Spend', color: '#00B4C5' }]}
						xAxisLabelFormatter={(value: number) => {
							if (value === 0) {
								return '0';
							} else if (value >= 1_000_000_000) {
								return '$' + Math.round(value / 1_000_000_000) + 'B';
							} else if (value >= 1_000_000) {
								return '$' + Math.round(value / 1_000_000) + 'M';
							} else if (value >= 1_000) {
								return '$' + Math.round(value / 1_000) + 'K';
							} else {
								return '$' + value.toFixed(2);
							}
						}}
						tooltipFormatter={(params: any) => {
							const dataPoint = Array.isArray(params) ? params[0] : params;
							return `${dataPoint?.name ?? ''}: $${dataPoint?.value ?? 0}`;
						}}
						onBarClick={(params: any) => {
							const workspace = sortedSpend?.find((item) => item.workspace_name === params?.name);
							handleBarChartOnClick({
								...params,
								data: {
									...(typeof params?.data === 'object' ? params.data : {}),
									workspace_id: workspace?.workspace_id
								}
							}, 'computeSpend');
						}}
					/>
				</Grid>
			</Grid>

			<Grid container spacing={2} px={{ xs: 1, md: 2 }} py={{ xs: 1, md: 1.5 }} pb={{ xs: 1, md: 2 }}>
				<Grid item xs={12} md={4} id="top-10-runtime-workspace">
					<RaceBarChart
						title="Top 10 RunTime Workspace"
						isLoading={loader.topTenRunTimeWorkspaceLoader}
						valueType="number"
						data={sortedTime?.map((item) => ({
							name: item.workspace_name,
							value: item.totalRunTime,
							workspace_id: item.workspace_id
						})) ?? []}
						series={[{ key: 'value', name: 'Run Time', color: '#00B4C5' }]}
						xAxisLabelFormatter={(value: number) => {
							if (value === 0) return '0';
							else if (value >= 1_000_000_000) return Math.round(value / 1_000_000_000) + 'B hrs';
							else if (value >= 1_000_000) return Math.round(value / 1_000_000) + 'M hrs';
							else if (value >= 1_000) return Math.round(value / 1_000) + 'K hrs';
							else return Math.round(value) + ' hrs';
						}}
						tooltipFormatter={(params: any) => {
							const dataPoint = Array.isArray(params) ? params[0] : params;
							const hours = Number(dataPoint?.value ?? 0);
							const days = hours / 24;
							return `${dataPoint?.name ?? ''} - ${hours.toFixed(1)} hrs / ${days.toFixed(1)} days`;
						}}
						onBarClick={(params: any) => {
							const workspace = sortedTime?.find((item) => item.workspace_name === params?.name);
							handleBarChartOnClick({
								...params,
								data: {
									...(typeof params?.data === 'object' ? params.data : {}),
									workspace_id: workspace?.workspace_id
								}
							}, 'runtime');
						}}
					/>
				</Grid>
				<Grid item xs={12} md={4} id="cost-vs-workspace-runtime">
					<DualAxisLineChart
						title="Cost Vs Workspace with RunTime"
						isLoading={loader.costByTime}
						data={costByDate ?? []}
						xKey="date"
						series={[
							{
								key: 'totalSpend',
								name: 'Cost',
								color: '#FF7A1A',
								yAxisIndex: 0
							},
							{
								key: 'totalRunTime',
								name: 'RunTime',
								color: '#00B578',
								yAxisIndex: 1
							}
						]}
						leftYAxisLabel="Cost"
						rightYAxisLabel="Run Time"
						leftYAxisFormatter={(value: number) => formatter.format(value).toString()}
						rightYAxisFormatter={(value: number) => `${compactFormatter.format(value)} hrs`}
						xAxisLabelFormatter={(value: string) => moment(value).format('MMM DD')}
						tooltipFormatter={(params: any[]) => {
							// X-axis label (top line)
							let html = `<div style="margin-bottom:4px;">${params[0].axisValueLabel}</div>`;

							// Loop through all series in this axis trigger
							params.forEach((p: any) => {
								const marker = p.marker; // preserves the colored legend icon
								const name = toTitleCase(p.seriesName);
								const value = p.value;

								// apply correct formatter based on series
								let formattedValue;

								if (p.seriesName.toLowerCase() === 'cost') {
									formattedValue = formatter.format(value);
								} else {
									// runtime
									formattedValue = `${compactFormatter.format(value)} hrs`;
								}

								html += `
									<div>
										${marker}
										<span>${name}: ${formattedValue}</span>
									</div>
								`;
							});

							return html;
						}}
						onLineClick={(params: any) =>
							handleLineChartOnClick(params, 'workspaceRuntime')
						}
					/>
				</Grid>
				<Grid item xs={12} md={4} id="dbu-vs-workspace-runtime">
					<DualAxisLineChart
						title="DBU Vs Workspace with RunTime"
						isLoading={loader.countByTime}
						data={countByDate ?? []}
						xKey="date"
						series={[
							{
								key: 'totalDbu',
								name: 'DBU',
								color: '#FF7A1A',
								yAxisIndex: 0
							},
							{
								key: 'totalRunTime',
								name: 'RunTime',
								color: '#00B578',
								yAxisIndex: 1
							}
						]}
						leftYAxisLabel="DBU"
						rightYAxisLabel="Run Time"
						leftYAxisFormatter={(value: number) => compactFormatter.format(value).toString()}
						rightYAxisFormatter={(value: number) => `${compactFormatter.format(value).toString()} hrs`}
						xAxisLabelFormatter={(value: string) => moment(value).format('MMM DD')}
						tooltipFormatter={(params: any[]) => {
							// X-axis label (top line)
							let html = `<div style="margin-bottom:4px;">${params[0].axisValueLabel}</div>`;

							// Loop through all series in this axis trigger
							params.forEach((p: any) => {
								const marker = p.marker; // preserves the colored legend icon
								const name = toTitleCase(p.seriesName);
								const value = p.value;

								// apply correct formatter based on series
								let formattedValue;

								if (p.seriesName.toLowerCase() === 'cost') {
									formattedValue = formatter.format(value);
								} else {
									// runtime
									formattedValue = `${compactFormatter.format(value)} hrs`;
								}

								html += `
									<div>
										${marker}
										<span>${name}: ${formattedValue}</span>
									</div>
								`;
							});

							return html;
						}}
						onLineClick={(params: any) =>
							handleLineChartOnClick(params, 'dbuWorkspaceRuntime')
						}
					/>
				</Grid>
			</Grid>

		</PageWrapper>
	);
};

export default Workspace;
